export const maxLengthValidatorKey = 'maxLength';
export const maxLengthValidator = (maxLength) => {
    return (value) => {
        const isValid = value !== null && value !== undefined && value.length <= maxLength;
        return {
            [maxLengthValidatorKey]: isValid,
        };
    };
};
//# sourceMappingURL=max-length.validator.js.map